var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.228 6.23v1.386H5.772V6.23h12.456ZM5.772 12.692h12.456v-1.386H5.772v1.386Zm0 5.076h12.456V16.4H5.772v1.368Z",
    fill: "#000"
  })));
};
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOC4yMjggNi4yMjk5OFY3LjYxNTk4SDUuNzcxOTdWNi4yMjk5OEgxOC4yMjhaTTUuNzcxOTcgMTIuNjkySDE4LjIyOFYxMS4zMDZINS43NzE5N1YxMi42OTJaTTUuNzcxOTcgMTcuNzY4SDE4LjIyOFYxNi40SDUuNzcxOTdWMTcuNzY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";